/** One cohort's final outcome — mirrors the server's RenewalOutcome. */
export type IOutcome = {
  total: number;
  renewed: number;
  lapsed: number;
  pending: number;
  rate: number;
  lapseRate: number;
};

export type IRenewalStats = {
  overall: IOutcome;
  auto: IOutcome;
  nonAuto: IOutcome;
};

export const EMPTY_OUTCOME: IOutcome = {
  total: 0,
  renewed: 0,
  lapsed: 0,
  pending: 0,
  rate: 0,
  lapseRate: 0,
};

export const EMPTY_STATS: IRenewalStats = {
  overall: EMPTY_OUTCOME,
  auto: EMPTY_OUTCOME,
  nonAuto: EMPTY_OUTCOME,
};

/** The two splits read against the headline rate. */
export const COHORTS: {
  key: "auto" | "nonAuto";
  label: string;
  note: string;
  bar: string;
}[] = [
  {
    key: "auto",
    label: "Auto",
    note: "Renews without the customer acting",
    bar: "bg-indigo-500",
  },
  {
    key: "nonAuto",
    label: "Non-auto",
    note: "Needs a payment to renew",
    bar: "bg-amber-500",
  },
];

/** Composition of a cohort — the three parts always add up to `total`. */
export const SEGMENTS: {
  key: "renewed" | "lapsed" | "pending";
  label: string;
  bar: string;
}[] = [
  { key: "renewed", label: "Renewed", bar: "bg-emerald-500" },
  { key: "lapsed", label: "Lapsed", bar: "bg-rose-500" },
  { key: "pending", label: "Awaiting", bar: "bg-slate-400 dark:bg-slate-500" },
];

/** Share of a total, as a CSS width. */
export const share = (part: number, total: number) =>
  `${total ? (part * 100) / total : 0}%`;
